import api from '@/plugins/axios'
import store from '@/store'

export default {
  namespaced: true,

  state: () => ({
    coins: [],           // GET /crypto/options
    loading: false
  }),

  getters: {
    coins: state => state.coins,

    getCoin: state => symbol =>
      state.coins.find(c => c.symbol === symbol),

    getNetworks: state => symbol =>
      state.coins.find(c => c.symbol === symbol)?.networks || []
  },

  mutations: {
    SET_COINS(state, coins) {
      state.coins = coins
    },

    SET_LOADING(state, value) {
      state.loading = value
    }
  },

  actions: {
    /**
     * FRONTEND OPTIONS
     * GET /crypto/options
     */
    async fetchCryptoOptions({ commit }) {
      commit('SET_LOADING', true)

      try {
        const { data } = await api.get('/crypto/options')

        if (!data.success) {
          throw new Error(data.message)
        }

        commit('SET_COINS', data.coins)
        return data.coins
      } finally {
        commit('SET_LOADING', false)
      }
    },

    /**
     * CREATE STATIC ADDRESS
     */
    async getStaticAddress(_, { coinType, network }) {
      const userId = store.getters.authUser?.user?._id

      if (!userId) {
        throw new Error('User not authenticated')
      }

      const { data } = await api.post('/crypto/static-address', {
        userId,
        coinType,
        network
      })

      if (!data.success) {
        throw new Error(data.message)
      }

      return data
    }
  }
}
